export default "__VITE_ASSET__Btz7X6kK__"